module.exports = __webpack_public_path__ + "static/dragonborn-red-bc03ff36a0d71b81a48c137aad5275be.png";